import { useLanguage } from "@/hooks/useLanguage";
import { Headphones, Palette, Globe, Zap } from "lucide-react";

const Features = () => {
  const { t } = useLanguage();

  const features = [
    {
      icon: Globe,
      titleKey: 'featureMultipleAlphabetsTitle',
      descKey: 'featureMultipleAlphabetsDesc',
      fallbackTitle: 'Multiple Alphabets',
      fallbackDesc: 'Support for NATO, ICAO, and international phonetic standards.',
    },
    {
      icon: Zap,
      titleKey: 'featureRealtimeTitle',
      descKey: 'featureRealtimeDesc',
      fallbackTitle: 'Real-time Conversion',
      fallbackDesc: 'Instant conversion as you type with zero delay.',
    },
    {
      icon: Headphones,
      titleKey: 'featureIPATitle',
      descKey: 'featureIPADesc',
      fallbackTitle: 'IPA Support',
      fallbackDesc: 'International Phonetic Alphabet for linguistic accuracy.',
    },
    {
      icon: Palette,
      titleKey: 'featureThemeTitle',
      descKey: 'featureThemeDesc',
      fallbackTitle: 'Dark & Light Themes',
      fallbackDesc: 'Choose your preferred theme for comfortable viewing.',
    },
  ];

  return (
    <section id="features" className="py-24 px-6 bg-muted/30">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-semibold mb-3">
            {t('featuresSectionTitle') || 'Powerful Features'}
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            {t('featuresSubtitle') || 'Everything you need for accurate phonetic text conversion.'}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {features.map((feature, index) => (
            <div
              key={feature.titleKey}
              className="group p-6 rounded-lg bg-card border border-border hover:border-foreground/20 transition-all animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <feature.icon className="w-5 h-5" />
              </div>
              <h3 className="text-lg font-medium mb-2">
                {t(feature.titleKey as any) || feature.fallbackTitle}
              </h3>
              <p className="text-muted-foreground text-sm leading-relaxed">
                {t(feature.descKey as any) || feature.fallbackDesc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
